import { useRef, useEffect } from 'react';
import CSS from './CloseButton.module.css';
import CloseIcon from '@/assets/icons/close.svg?component';

type CloseButtonProps = { onClick?: () => void };

export const CloseButton = ({ onClick }: CloseButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !onClick) return;

    // iOS WebView swallows pointer events on fixed elements that sit above an
    // iframe regardless of z-index. Capture-phase native listeners fire before
    // the iframe can intercept the touch, making the button reliably tappable.
    const handler = (e: Event) => {
      e.stopPropagation();
      onClick();
    };

    el.addEventListener('touchend', handler, { capture: true, passive: true });
    el.addEventListener('click', handler, { capture: true });

    return () => {
      el.removeEventListener('touchend', handler, { capture: true } as EventListenerOptions);
      el.removeEventListener('click', handler, { capture: true } as EventListenerOptions);
    };
  }, [onClick]);

  return (
    <button ref={ref} data-close-btn className={CSS.closeButton} role="button">
      <CloseIcon />
    </button>
  );
};
